<template>
  <div class="container-fuild page-500-bg">
    <div class="container">
      <div class="d-flex flex-wrap">
        <div
          class="
            col-xl-5 col-lg-12 col-md-12 col-sm-12 col-12
            d-flex
            flex-column
            align-items-center
            justify-content-center
          "
        >
          <div class="page-500-text-box text-center text-lg-start">
            <img :src="this.$store.state.systemLogoX" alt="" />
            <h1>An unknown error has occurred on the server.</h1>
            <img :src="require(`/src/assets/img/Forie_Network_Black.svg`)" />
          </div>
        </div>
        <div
          class="
            col-xl-7 col-lg-12 col-md-12 col-sm-12 col-12
            d-flex
            justify-content-center
          "
        >
          <div class="page-500-images">
            <div class="img-box">
              <img :src="require(`/src/assets/img/500-server-t-4.png`)" />
              <div class="mask"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.page-500-bg{
  height: 100vh;
    display: flex;
    align-items: center;
    padding: 20px 0;
}
.page-500-text-box img {
  max-width: 200px;
}

.page-500-text-box h1 {
  max-width: 384px;
  margin-top: 82px;
  margin-bottom: 72px;
}
.page-500-images .img-box {
  position: relative;
  height: 661px;
  background: no-repeat;
}

.page-500-images .img-box > img {
  max-width: 600px;
  width: 100%;
}

.page-500-images .img-box .mask {
  content: "";
  position: absolute;
  left: 52px;
  top: 60px;
  width: 100%;
  height: calc(100% - 60px);
  background: #005eb5;
  mix-blend-mode: screen;
  border-radius: 100px;
}
.page-500-images .img-box::before {
  content: "";
  position: absolute;
  width: 100%;
  height: calc(100% - 60px);
  left: 52px;
  top: 60px;
  mix-blend-mode: normal;
  border: 1px solid #005eb5;
  box-sizing: border-box;
  border-radius: 100px;
}
</style>
